import qs from 'qs';

import config from 'src/config/config';
import { ERequestType } from './enumRequest';

export const marketPrice = {
  getMarketPrice: (params: any) => {
    const { paymentId, sourceCurrencyId, targetCurrencyId, sourceCurrencyAmount } = params;
    const queryParams = qs.stringify({ sourceCurrencyId, targetCurrencyId, sourceCurrencyAmount });

    return fetch(`${config.apiUrl}/v1/client/market-price/${paymentId}?${queryParams}`, {
      method: ERequestType.GET,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },
};
